import { bundleProductsToProductConfigurations, convertSkuIdsToSkuUuidsForProductConfigurations, getAdditionalAndIncludedCoreSalesServiceSeatsTotalInProductConfiguration, getAdditionalProductConfigurations, getCheckoutProductConfigurations, getCheckoutProductConfigurationsForSeats, getIncludedCoreSeatsQuantity, getIncludedSeatQuantityForProductConfiguration, getInitialCoreSeatsTotalForProductConfiguration, getNonRecurringProductConfigurations, getOfferProductConfigurations, getProductConfigurationForSeats, getProductLevelForCoreSeats, getProductVersionConfigsWithUnits, getProductsAndPacksForQueryParams, getSortedProductConfigurations, getSuiteProductConfigurations, productConfigurationsToBundleProducts } from 'pricing-pages-lib/utils/productConfigUtils';
import { getBundledProductLinesForSkuId } from 'pricing-pages-lib/utils/productsUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { isQuantityPackDetails } from '../v2/utils/typeguards';
import { productForSkuIdSelector, productSelector, skuIdHasBundledProductsSelector, skuSelector } from './ProductsSelectors';
import { transformState } from './SelectorUtils';
export const checkoutProductConfigurationsSelector = createSelectorFromUtil(getCheckoutProductConfigurations, transformState);
export const suiteProductConfigurationsSelector = createSelectorFromUtil(getSuiteProductConfigurations, transformState);
export const offerProductConfigurationsSelector = createSelectorFromUtil(getOfferProductConfigurations, transformState);
export const nonRecurringProductConfigurationsSelector = createSelectorFromUtil(getNonRecurringProductConfigurations, transformState);
export const getFirstHubSkuIdFromProductConfigurations = (state, {
  productConfigurations
}) => {
  // find the first hub or bundle in the product configurations
  const foundProductConfig = productConfigurations.find(({
    skuId
  }) => {
    const {
      productLine,
      productLevel
    } = productForSkuIdSelector(state, {
      skuId
    });
    const isBundledProduct = skuIdHasBundledProductsSelector(state, {
      skuId
    });
    return productLine && productLevel || isBundledProduct;
  });
  if (!foundProductConfig) return null;
  const foundSku = skuSelector(state, {
    skuId: foundProductConfig.skuId
  });
  if (!foundSku) return null;
  return isQuantityPackDetails(foundSku) ? foundSku.productVersionSkuId : foundSku.skuId;
};
export const productVersionConfigsWithUnitsSelector = createSelectorFromUtil(getProductVersionConfigsWithUnits, transformState);
export const bundledProductLinesForSkuIdSelector = createSelectorFromUtil(getBundledProductLinesForSkuId, transformState);
export const productVersionFromConfigsSelector = (state, {
  productConfigurations,
  productLine
}) => {
  for (let i = 0; i < productConfigurations.length; i++) {
    const sku = skuSelector(state, {
      skuId: productConfigurations[i].skuId
    });
    const product = productSelector(state, {
      productId: sku.productId
    });
    const bundledProductLines = bundledProductLinesForSkuIdSelector(state, {
      skuId: sku.skuId
    });
    if ((product === null || product === void 0 ? void 0 : product.productLine) === productLine || bundledProductLines.includes(productLine)) {
      // If the sku we selected is a quantity pack, it will have this field
      if (isQuantityPackDetails(sku)) {
        return skuSelector(state, {
          skuId: sku.productVersionSkuId
        });
      }
      return skuSelector(state, {
        skuId: sku.skuId
      });
    }
  }
  return null;
};
export const productsAndPacksForQueryParamsSelector = createSelectorFromUtil(getProductsAndPacksForQueryParams, transformState);
export const productLevelForCoreSeatsSelector = createSelectorFromUtil(getProductLevelForCoreSeats, transformState);
export const includedCoreSeatsQuantitySelector = createSelectorFromUtil(getIncludedCoreSeatsQuantity, transformState);
export const productConfigurationForSeatsSelector = createSelectorFromUtil(getProductConfigurationForSeats, transformState);
export const sortedProductConfigurationsSelector = createSelectorFromUtil(getSortedProductConfigurations, transformState);
export const checkoutProductConfigurationsForSeatsSelector = createSelectorFromUtil(getCheckoutProductConfigurationsForSeats, transformState);
export const initialCoreSeatsTotalForProductConfigurationSelector = createSelectorFromUtil(getInitialCoreSeatsTotalForProductConfiguration, transformState);
export const additionalAndIncludedCoreSalesServiceSeatsTotalInProductConfigurationSelector = createSelectorFromUtil(getAdditionalAndIncludedCoreSalesServiceSeatsTotalInProductConfiguration, transformState);
export const includedSeatQuantityForProductConfigurationSelector = createSelectorFromUtil(getIncludedSeatQuantityForProductConfiguration, transformState);
export const additionalProductConfigurationsSelector = createSelectorFromUtil(getAdditionalProductConfigurations, transformState);
export const convertSkuIdsToSkuUuidsForProductConfigurationsSelector = createSelectorFromUtil(convertSkuIdsToSkuUuidsForProductConfigurations, transformState);
export const productConfigurationsToBundleProductsSelector = createSelectorFromUtil(productConfigurationsToBundleProducts, transformState);
export const bundleProductsToProductConfigurationsSelector = createSelectorFromUtil(bundleProductsToProductConfigurations, transformState);